exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Styles for Average Daily Vault Balance */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/average-daily-vault-balance/average_daily_vault_balance.scss
// module id = 973
// module chunks = 1